var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBookingsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.087 2.12646L14.087 1.35571C14.087 0.893261 13.7739 0.584961 13.3043 0.584961C12.8348 0.584961 12.5217 0.893261 12.5217 1.35571L12.5217 2.12646L8.6087 2.12646L8.6087 1.35571C8.6087 0.893261 8.29565 0.584961 7.82609 0.584961C7.35652 0.584961 7.04348 0.893261 7.04348 1.35571L7.04348 2.12646L3.13043 2.12646L3.13043 1.35571C3.13043 0.893261 2.81739 0.584961 2.34783 0.584961C1.87826 0.584961 1.56522 0.893261 1.56522 1.35571L1.56522 2.12646C0.704348 2.12646 0 2.82014 0 3.66797L0 14.4585C0 15.3063 0.704348 16 1.56522 16L14.087 16C14.9478 16 15.6522 15.3063 15.6522 14.4585L15.6522 3.66797C15.6522 2.74306 14.9478 2.12646 14.087 2.12646ZM14.087 13.6877C14.087 14.1502 13.7739 14.4585 13.3043 14.4585L2.34783 14.4585C1.87826 14.4585 1.56522 14.1502 1.56522 13.6877L1.56522 5.98022C1.56522 5.51777 1.87826 5.20947 2.34783 5.20947L13.3043 5.20947C13.7739 5.20947 14.087 5.51777 14.087 5.98022L14.087 13.6877Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04346 12.3771L4.22607 9.60241L5.32173 8.52336L7.04346 10.1419L10.3304 6.90479L11.4261 7.98384L7.04346 12.3771Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBookingsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bookings_icon.c1f01db7.svg";
export { ForwardRef as ReactComponent };